
<v-card-iterator
    v-if           = "items"
    :label         = "$t('contract.title')"
    :items         = "items"
    :columns       = "columns"
    :item-height   = "itemHeight"
    :filter-height = "filterHeight"
    :filter        = "filter"
    :key           = "refreshCount"
    class          = "w-100"
    ref="iterator"
>
    <template v-slot:toolbar>
        <div class="pl-1 v-flex" style="margin-top: -1px;">
            <slot name="toolbar"></slot>
        </div>
    </template>
    <template v-slot:filter>
        <slot name="filter"></slot>
    </template>
    <template v-slot:card="{ item }">
        <div :class = "background(selected, item)">
            <slot name="card" v-bind:item="{ item }" />
        </div>
    </template>
</v-card-iterator>
